/* Change this file to get your personal Portfolio */

// Summary And Greeting Section

import emoji from "react-easy-emoji";

const illustration = {
  animated: true // set to false to use static SVG
};

const greeting = {
  username: "Ravi Bikram Giri (Aaditya)",
  title: "Hello Everyone, I'm Aaditya",
  subTitle: emoji(
    "A diligent, hard-working, and dedicated individual offering good educational background, work experience, and exceptional organizational skills in order to work in a challenging and pro-learning environment. Have completed a Higher Secondary Education level in a Management stream as a hotel management major in Nepal and I am studying BSc (Hons) Computing at The British College. Working with BARPA IT Solution as a professional Software Developer, Web Designer, Mobile Developer. Have skills and experience to build functional, attractive sites."
  ),
  resumeLink:
    "https://ravibikram.com.np/#resume",
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/info-aaditya",
  linkedin: "https://www.linkedin.com/in/info-aaditya",
  gmail: "gaadityag@gmail.com",
  gitlab: "https://gitlab.com/info-aaditya",
  facebook: "https://www.facebook.com/barpatech",
  //medium: "https://medium.com/",
  // stackoverflow: "https://stackoverflow.com/",
  instagram: 'https://www.instagram.com/info_aaditya/',
  twitter: 'https://twitter.com/info__aaditya',
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY REACT JS,REACT NATIVE DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji(
      "⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"
    ),
    emoji(
      "⚡ Integration of third party services such as Firebase/ AWS / Digital Ocean"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "TypeScript",
      fontAwesomeClassname: "fa fa-code"
    },
    {
      skillName: "Next.js",
      fontAwesomeClassname: "fa fa-code"
    },
    {
      skillName: "React",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "React Native",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "AWS",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "The British College (Leeds Beckett University)",
      logo: require("./assets/images/tbc.png"),
      subHeader: "BSc (Hons) Computing Programme (Final Year)",
      duration: "March 2020 - November 2021",
      desc: 
        "Completed BSc (Hons) Computing Programme",
      descBullets: [
        "⚡ I have studied basic software engineering subjects like Oracle DBMS, Intelligent Systems, Java, Research, etc.",
        "⚡ Apart from this, I have done courses on CyberSecurity, JavaScript, React Native, React Js,  IoT and Wordpress Development.",
        // "⚡ Participate in a project of Digitization Nepal",
      ]
    },
    {
      schoolName: "International School Of Management And Technology (ISMT)",
      logo: require("./assets/images/ismt.png"),
      subHeader: "BSc (Hons) Computing Programme (First 2 Year)",
      duration: "September 2017 - November 2019",
      desc:
        "Ranked top 10% in the program. Took courses about Software Engineering, Website Development, Web Security, Operating Systems, Server Manaagement ...",
      descBullets: [
        "⚡ I have studied basic software engineering subjects like DSA, Algorithms, DBMS, .Net, Network Security, Networking, BI, Java etc.",
        "⚡ Participated in the research of Traffic Management System, SchoolManagement System, E-commerce Web and so on."]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend / Design", //Insert stack or technology you have experience in
      progressPercentage: "85%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "75%"
    },
    {
      Stack: "Programming",
      progressPercentage: "80%"
    }
  ],
  displayCodersrank: true // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "SENOIR SOFTWARE DEVELOPER",
      company: "BARPA IT Solution",
      companylogo: require("./assets/images/barpa.png"),
      date: "August 2023 – Present",
      desc:
        "Changing lives of developers one line of code at a time.",
      descBullets: [
        "Developed scalable backend systems using AWS, Node.js and MongoDB.",
        "Led project teams to successful delivery within deadlines.",
        "Collaborated with cross-functional teams to gather requirements.",
        "Mentored junior developers for improved team performance.",
        "Resolved complex technical issues with attention to detail.",
        "Implemented CI/CD pipelines for faster deployment.",
        "Stayed updated on industry trends and emerging tech.",
        "Shared expertise through presentations and workshops."
      ]        
    },
    {
      role: "JUNIOR SOFTWARE DEVELOPER",
      company: "Vine Software Innovation Company",
      companylogo: require("./assets/images/vine.png"),
      date: "March 2018 – Present",
      desc:
        "Changing lives of developers one line of code at a time.",
      descBullets: [
        "Custom building mobile applications",
        "Custom building web applications",
        "Cloning and building websites",
        "Creating tutorials"
      ]
    },
    {
      role: "WORDPRESS DEVELOPER",
      company: "BARPA IT Solution",
      companylogo: require("./assets/images/barpa.png"),
      date: "November 2017 – Present",
      desc:
        "I lead  wordpress developers building the website of a company for their company Portfolio.",
      descBullets: [
        "Custom building Website",
        "Coaching",
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  githubConvertedToken: process.env.REACT_APP_GITHUB_TOKEN,
  githubUserName: "info-aaditya", // Change to your github username to view your profile in Contact Section.
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/mobile-app.png"),
      projectName: "School Traffic Management System",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "fa"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/software-development.jpg"),
      projectName: "Traffic Management System",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: ""
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Introduction to Cybersecurity",
      subtitle:
        "Digital Badge was issued to Ravi Bikram Giri by Cisco on 7 May 2020.",
      image: require("./assets/images/cybersecurity.png"),
      footerLink: [
        // {
        //   name: "Certification",
        //   url: 
        //     ""
        // },
        {
          name: "Badge",
          url: 
            "https://www.youracclaim.com/badges/542e0812-9be8-4156-9b78-0be55f6fea17/linked_in_profile"
        },
        // {
        //   name: "Award Letter",
        //   url:
        //     ""
        // }
      ]
    },
    {
      title: "Networking Academy Learn-A-Thon 2020",
      subtitle:
        "Digital Badge was issued to Ravi Bikram Giri by Cisco on on 27 May 2020.",
      image: require("./assets/images/learnathon.png"),
      footerLink: [
        {
          name: "Badge",
          url:
            "https://www.youracclaim.com/badges/49b33302-45c1-441c-93a0-b7aa47d14280/linked_in_profile"
        }
      ]
    },

    {
      title: "Introduction to IoT",
      subtitle: "Digital Badge was issued to Ravi Bikram Giri by Cisco on 18 November 2020.",
      image: require("./assets/images/Intro2IoT.png"),
      footerLink: [
        // {name: "Certification", url: ""},
        // {
        //   name: "Final Project",
        //   url: ""
        // },
        {
          name: "Badge",
          url:
            "https://www.youracclaim.com/badges/530088fa-4d87-43e6-99c6-7e9dc9fb91d0?source=linked_in_profile"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",

  blogs: [
    {
      url:
        "https://ravibikram.com.np/#blog",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://ravibikram.com.np/#blog",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    },
    {
      url: "https://ravibikram.com.np/#blog",
      title: "Why REACT NATIVE is The Best?",
      description:
        "React Native combines the best parts of native development with React, a best-in-class JavaScript library for building user interfaces. It is written in JavaScript—rendered with native code."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    ""
  ),

  talks: [
    {
      title: "",
      subtitle: "",
      slides_url: "",
      event_url: ""
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    ""
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  // number: "(+977) 984 3650 354",
  email_address: "info@barpait.com"
};

// Twitter Section

const twitterDetails = {
  userName: "info__aaditya", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
